import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Popconfirm, Space, Tag, notification } from "antd";
import { useState } from "react";
import CreateConfig from "./CreateConfig";
import { MemberService } from "../../services/MemberService";
import { Link } from "react-router-dom";

export default function CustomerLevelConfig() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Level Name',
            align: 'center',
            dataIndex: 'level_name',
            key: 'level_name',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Min Volume',
            align: 'center',
            dataIndex: 'accu_volume',
            key: 'accu_volume',
            render: (value, record) => {
                return `${Number(value).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })} ${record?.accu_volume_currency}`
            },
        },
        {
            title: 'Min Transaction',
            align: 'center',
            dataIndex: 'total_transaction',
            key: 'total_transaction',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Cashback Rate',
            align: 'center',
            dataIndex: 'cashback_rate',
            key: 'cashback_rate',
            render: (value, record) => {
                return `${value * 100} %`
            },
        },
        {
            title: 'Sort Level',
            align: 'center',
            dataIndex: 'sort_level',
            key: 'sort_level',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Reward',
            align: 'center',
            dataIndex: 'rewards',
            key: 'rewards',
            render: (value, record) => {
                const itemLength = value?.length;
                let reward = '';
                if(itemLength > 1){
                    reward = `${itemLength} Coupons`
                }else{
                    reward = `${itemLength} Coupon`
                }
                return <Link to={`reward/${record.id}`}>{reward}</Link>
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" justify="center" wrap="wrap">
                        <span onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </span>
                        <Popconfirm
                            placement="left"
                            title="Delete the config"
                            description="You cannot rollback this config."
                            okText="Yes"
                            cancelText="No"
                            onConfirm={(e) => {
                                onDelete(record)
                            }}
                        >
                            <Button type="primary" danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </Popconfirm>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await MemberService.getCustomerLevelConfig(payload)
        return res
    }


    const onDelete = async (record: any) => {

        const res = await MemberService.deleteCustomerLevelConfig(record.id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }

    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateConfig
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateConfig>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Config',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Customer Level Config"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
